import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { protectedRoute, redirect, rootRoute } from './_root';

// ─── Index redirect ──────────────────────────────────────────────

export const indexRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/itineraries' });
  },
});

// ─── Help ────────────────────────────────────────────────────────

export const helpRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'help',
  component: lazyRouteComponent(() =>
    import('@help/pages/help').then((m) => ({
      default: m.HelpPage,
    }))
  ),
});

// ─── Optigest (admin) ────────────────────────────────────────────

export const managementOptigestRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'management/optigest',
  component: lazyRouteComponent(() =>
    import('@optigest/pages/optigest-api-tester').then((m) => ({
      default: m.OptigestApiTesterPage,
    }))
  ),
});

// ─── Product API (admin) ─────────────────────────────────────────

// Key + IP allow-list + request tester on one page. Sits beside OptiGest in
// the AdminMenu's Integrations section rather than under System Configuration.
export const managementProductApiRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'management/product-api',
  component: lazyRouteComponent(() =>
    import('@auth/pages/product-api-admin').then((m) => ({
      default: m.ProductApiAdminPage,
    }))
  ),
});

// ─── System brief (stakeholder, direct URL only) ─────────────────

// Intentionally absent from every nav and menu: the URL is handed to a
// stakeholder directly. Access is enforced by `system_brief:read` on the API,
// not by the route's obscurity.
export const systemBriefRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'system-brief',
  component: lazyRouteComponent(() =>
    import('@/pages/system-brief').then((m) => ({
      default: m.SystemBriefPage,
    }))
  ),
});

// ─── Sandbox (dev) ───────────────────────────────────────────────

export const sandboxAgentPanelRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'sandbox/agent-panel',
  component: lazyRouteComponent(() =>
    import('@/pages/sandbox-agent-panel').then((m) => ({
      default: m.SandboxAgentPanelPage,
    }))
  ),
});

// ─── Itinerary builder eval (unlisted; no sidebar / list button) ─
// Auth required (uses org sold data via live SQL). Reachable only by
// typing `/itinerary-builder-eval` — not a workspace `?mode=`.
export const itineraryBuilderEvalRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'itinerary-builder-eval',
  component: lazyRouteComponent(() =>
    import('@itineraries/pages/itinerary-builder-eval').then((m) => ({
      default: m.ItineraryBuilderEvalPage,
    }))
  ),
});

// ─── 404 catch-all ───────────────────────────────────────────────

export const notFoundRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '*',
  component: lazyRouteComponent(() =>
    import('@/shared/ui/not-found').then((m) => ({
      default: m.NotFoundPage,
    }))
  ),
});
